import Vue from 'vue'
import VueRouter from 'vue-router'
import Frame from "../src/components/frame.vue";
import {
	RouterTabRoutes
} from 'vue-router-tab';

const importPage = view => () =>
	import(`../page/${view}.vue`)

Vue.use(VueRouter);

const routes = [{
		path: '/',
		component: Frame,
		meta: {
			title: '主页' // 页签标题
		},
		children: [
			// 引入 RouterTab 内置路由以支持 iframe 页签
			...RouterTabRoutes,
			{
				path: '/', // 默认页和父级路由一致
				name: 'index',
				component: importPage('index'),
				meta: {
					title: '主页' // 页签标题
				}
			},
			{
				path: '/user',
				name: 'user',
				component: importPage('user/list'),
				meta: {
					title: '用户信息' // 页签标题
				}
			},
			{
				path: '/user/new',
				name: 'user_new',
				component: importPage('user/new'),
				meta: {
					title: '用户新增' // 页签标题
				}
			},
			{
				path: '/user/detail',
				name: 'user_detail',
				component: importPage('user/detail'),
				meta: {
					title: '用户详情' // 页签标题
				}
			},
			{
				path: '/device',
				name: 'device',
				component: importPage('device/list'),
				meta: {
					title: '设备列表' // 页签标题
				}
			},
			{
				path: '/device/new',
				name: 'device_new',
				component: importPage('device/new'),
				meta: {
					title: '新增设备' // 页签标题
				}
			},
			{
				path: '/device/detail',
				name: 'device_detail',
				component: importPage('device/detail'),
				meta: {
					title: '设备详细' // 页签标题
				}
			},
			{
				path: '/device/audio',
				name: 'device_audio',
				component: importPage('device/audio'),
				meta: {
					title: '回放' // 页签标题
				}
			},
			{
				path: '/controlData',
				name: 'controlData',
				component: importPage('controlData/list'),
				meta: {
					title: '控制数据' // 页签标题
				}
			},
			{
				path: '/statuData',
				name: 'statuData',
				component: importPage('statuData/list'),
				meta: {
					title: '状态数据' // 页签标题
				}
			},
			{
				path: '/deviceType',
				name: 'deviceType',
				component: importPage('deviceType/list'),
				meta: {
					title: '设备型号' // 页签标题
				}
			},



		]
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: importPage('dashboard/dashboard'),
	}
];

const router = new VueRouter({
	routes
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default router;
